import { FaCheck, FaTrophy } from "react-icons/fa"

const StatusPipeline = ({ statusItems, progress ,onStatusChange }) => {
  let reachedCurrent = false;
  return (
    <div>
      <div style={{ 
        background: 'linear-gradient(to right, #f0f9ff, #faf5ff, #fef2f2)', 
        borderRadius: '12px', 
        padding: '12px', 
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)', 
        border: '1px solid #f3f4f6'
      }}>
        <div 
          className="pipeline-scroll"
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            overflowX: 'auto',
            overflowY: 'hidden',
            paddingBottom: '8px',
            marginBottom: '-8px',
            minHeight: '100px'
          }}
        >
          <style>
            {`
              .pipeline-scroll::-webkit-scrollbar {
                height: 8px;
              }
              .pipeline-scroll::-webkit-scrollbar-track {
                background: #f1f5f9;
                border-radius: 4px;
                margin: 0 10px;
              }
              .pipeline-scroll::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 4px;
              }
              .pipeline-scroll::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
              }
              @keyframes pulse {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.5; }
              }
            `}
          </style>
          
          {statusItems.map((item, index) => {
            let completed = false;
            let current = false;
            let topLabel = 'Pending';      // above text
            let bottomLabel = item.label; // below text (always item label)

            if (!reachedCurrent && item.value === progress) {
              current = true;
              reachedCurrent = true;
              topLabel = 'Current';
            } 
            else if (!reachedCurrent) {
              completed = true;
              topLabel = 'Completed';
            }

            return <div 
              key={index} 
              id={`status-item-${index}`}
              style={{ 
                position: 'relative',
                minWidth: '150px',
                flexShrink: 0,
                height: '100%',
                cursor: 'pointer'
              }}
            >
              <div style={{ 
                backgroundColor: 'white', 
                borderRadius: '8px', 
                padding: '10px', 
                border: completed ? '2px solid #22c55e' : 
                        current ? '2px solid #eab308' : '1px solid #e5e7eb',
                boxShadow: completed ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 
                         current ? '0 20px 25px -5px rgba(0, 0, 0, 0.1)' : 
                         '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                transform: current ? 'scale(1.05)' : 'scale(1)',
                opacity: current ? 1 : 0.6,
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                  <div style={{ 
                    width: '32px', 
                    height: '32px', 
                    borderRadius: '50%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    flexShrink: 0,
                    background: completed ? 'linear-gradient(135deg, #4ade80, #16a34a)' : 
                              current ? 'linear-gradient(135deg, #fbbf24, #d97706)' : 
                              '#f3f4f6',
                    boxShadow: completed || current ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none',
                    border: !completed && !current ? '2px solid #d1d5db' : 'none'
                  }}>
                    {completed ? (
                      <FaCheck style={{ color: 'white' }} size={16} />
                    ) : current ? (
                      <div style={{ position: 'relative', width: '24px', height: '24px' }}>
                        <div style={{
                          position: 'absolute',
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                          top: '4px',
                          left: '4px'
                        }} />
                        <div style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          position: 'absolute',
                          top: '6px',
                          left: '6px'
                        }} />
                      </div>
                    ) : item.status === "Won" ? (
                      <FaTrophy style={{ color: '#9ca3af' }} size={16} />
                    ) : (
                      <div style={{
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        backgroundColor: '#9ca3af'
                      }} />
                    )}
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{
                      fontSize: '11px',
                      fontWeight: 'bold',
                      color: completed ? '#166534' : current ? '#854d0e' : '#6b7280',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {topLabel}
                    </div>
                    <div style={{
                      fontSize: '13px',
                      fontWeight: '600',
                      color: current ? '#1f2937' : '#374151',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {bottomLabel}
                    </div>
                  </div>
                </div>
              </div>
              
              {index < statusItems.length - 1 && (
                <div style={{
                  position: 'absolute',
                  right: '-12px',
                  top: '50%',
                  transform: 'translateY(-50%) rotate(45deg)',
                  width: '24px',
                  height: '24px',
                  backgroundColor: completed ? '#22c55e' : 
                                current ? '#eab308' : '#d1d5db',
                  zIndex: 10
                }} />
              )}
            </div>
          })}
        </div>
      </div>
    </div>
  )
}

export default StatusPipeline